import { t } from 'i18next';

import { MenuDivider, MenuHeader, MenuItem } from '@/components/molecules/Menu';

import type { BreadcrumbLocation, LocationsByStatus } from './types';

export interface LocationDropdownItemsProps {
    locationsByStatus: LocationsByStatus;
    onLocationClick: (location: BreadcrumbLocation) => void;
    /** The location the reader is on, marked in the list like the current client. */
    selectedLocationId?: number;
}

export default function LocationDropdownItems(props: LocationDropdownItemsProps) {
    const { locationsByStatus, onLocationClick, selectedLocationId } = props;

    return (
        <div data-location="sorted">
            <span>
                <MenuDivider />
                <MenuHeader>{t('common.labels.activeLocations')}</MenuHeader>
                {locationsByStatus.active.map((location) => (
                    <MenuItem
                        key={`location_${location.id}`}
                        active={location.id === selectedLocationId}
                        onClick={() => onLocationClick(location)}>
                        {location.name}
                    </MenuItem>
                ))}
            </span>
            {locationsByStatus.inactive.length > 0 && (
                <span>
                    <MenuDivider />
                    <MenuHeader>{t('common.labels.inactiveLocations')}</MenuHeader>
                    {locationsByStatus.inactive.map((location) => (
                        <MenuItem
                            key={`location_inactive_${location.id}`}
                            active={location.id === selectedLocationId}
                            onClick={() => onLocationClick(location)}>
                            {location.name}
                        </MenuItem>
                    ))}
                </span>
            )}
        </div>
    );
}
